import { useParams } from 'react-router-dom';
import { CircleCheck } from 'lucide-react';

import { COACH_ACTIVITY_STATUS } from '@/app/coachActivity/enums';

import Page from '@/components/layout/Page';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import BackButton from '@/components/common/BackButton';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

import ApplicationStepsContinue from './components/ApplicationStepsContinue';

import { useCoachActivity, useCoachActivities } from '@/data/coachActivity';

const EditApplicationPage = () => {
  const params = useParams();
  const coachActivity = useCoachActivity(params.coachActivityId);
  const coachActivities = useCoachActivities();

  if (coachActivity.isLoading && !coachActivity.data) {
    return null;
  }

  if (coachActivities.isLoading && !coachActivities.data) {
    return null;
  }

  if (!coachActivity.data) {
    return null;
  }

  return (
    <Page>
      <BackButton to={`/setting`} />
      <div className="p-8">
        <HorizontalLogo />
      </div>

      <Card>
        <CardHeader>
          <CardTitle>
            {[
              COACH_ACTIVITY_STATUS.PENDING,
              COACH_ACTIVITY_STATUS.REJECTED
            ].includes(coachActivity.data.status)
              ? `Continue ${coachActivity.data.activity.title} Application`
              : `Application for ${coachActivity.data.activity.title}`}
          </CardTitle>
        </CardHeader>
        <CardContent>
          {coachActivity.data.status === COACH_ACTIVITY_STATUS.APPROVED && (
            <Alert variant="success">
              <CircleCheck size={18} />
              <AlertTitle>Approved</AlertTitle>
              <AlertDescription>
                Your application has been approved! Refine your offerings and
                set some availability to go live! 🤙
              </AlertDescription>
            </Alert>
          )}
          <ApplicationStepsContinue coachActivityId={params.coachActivityId} />
        </CardContent>
      </Card>
      <div className="p-10"></div>
    </Page>
  );
};

export default EditApplicationPage;
